export default {
  event: {
    title: "Esemény statiszika",
    fields: {
      age: "Kor",
      methodOfTreatment: "Kezelés módja",
      hasWapps: "Wapps?",
      bloodType: "Vértípus",
      inhibitor: "Gátlótest?",
      factorActivities: "Hiányzó faktorok",
      eventType: "Esemény típus"
    },
    exportFields: {
      patientName: "Páciens Név",
      doctorName: "Orvos név",
      centerName: "Központ neve",
      age: "Életkor",
      socialSecurityNo: "TAJ szám",
      weight: "Testsúly",
      walkingAid: "Járássegítő",
      movementActivity: "Mozgás aktivitás",
      treatmentMethod: "Kezelés módja",
      factorActivities: "Faktorok aktivitása %",
      targetJoints: "Cél izületek",
      targetJointTypes: "Cél izületek",
      otherTargetJoint: "Egyéb izület",
      hasInhibitor: "Gátlótest",
      eventType: "Esemény típusa",
      eventTime: "Esemény időpontja",
      eventMeta: "Esemény részletei",
      isOnTime: "Időben történő",
      administeredDrugName: "Gyógyszer neve",
      administeredTotalAmount: "Mennyiség",
      administeredTakeUnit: "Mértékegység",
      administeredCount: "Doboz db",
      administeredDrugType: "Termék típusa"
    }
  },
  fileType: {
    "xlsx": "Excel 2007 (xlsx)",
    "csv": "Szöveges fájl (csv)"
  }
}
